import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Grid,
  Box,
  Drawer,
  List,
  styled,
  BadgeProps,
  Badge,
  Link,
  MenuItem,
  Menu,
  Typography,
} from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface NavbarProps {
  mobileDrawerOpen?: boolean;
  onMobileDrawerClose?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ mobileDrawerOpen, onMobileDrawerClose }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const drawerOpen = mobileDrawerOpen !== undefined ? mobileDrawerOpen : isMobileDrawerOpen;

  const openMobileDrawer = () => {
    if (mobileDrawerOpen !== undefined) {
      return;
    }
    setIsMobileDrawerOpen(true);
  };

  const closeMobileDrawer = () => {
    if (onMobileDrawerClose) {
      onMobileDrawerClose();
    } else {
      setIsMobileDrawerOpen(false);
    }
  };
  const [nestedAnchorEl, setNestedAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const [currentPath, setCurrentPath] = useState<string>("");

  useEffect(() => {
    setCurrentPath(window.location.pathname);

  }, []);


  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNestedMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (nestedAnchorEl) {
      setNestedAnchorEl(null);
    } else {
      setNestedAnchorEl(event.currentTarget);
    }
  };

  const handleNestedMenuClose = () => {
    setNestedAnchorEl(null);
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleMobileDrawer = () => {
    if (mobileDrawerOpen !== undefined) {
      if (onMobileDrawerClose) onMobileDrawerClose();
      return;
    }
    setIsMobileDrawerOpen(!isMobileDrawerOpen);
  };

  const handleBack = () => {
    toggleMobileDrawer();
  };
  const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    "& .MuiBadge-badge": {
      // right: -3,
      // top: 20,
      // border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  }));
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        background: "transparent",
        pb: "12px",      

      }}
    >
      <AppBar        
        sx={{
          top: "24px",
          padding: "2px",
          bgcolor:'transparent',
          boxShadow:'none',
          position:'inherit',
          width: "auto",
          right: "auto",
        }}
      >
        <Toolbar style={{ minHeight: "50px", paddingRight: "8px" }}>

          <Grid sx={{ display: { xs: "none", md: "flex" } }}>
            <nav>
              <Button
                href="/Home"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Home
              </Button>
              <Button
                href="/Shop"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Shop
              </Button>
              
              {/* <Button
                href="/"
                sx={{
                  color: "#fff",
                  fontWeight: "300",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Sweat Shirts
              </Button> */}

              {/* <Button
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  fontWeight: "300",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
                aria-controls="products-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                endIcon={<ArrowDropDownIcon />}
              >
                Shop
              </Button> */}
              
              
              <Button
                href="/Gallery"
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  py: "2px",
                  px: "10px",
                  mr: "6px",
                  fontWeight: "300",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                Gallery
              </Button>
            </nav>
          </Grid>


          <IconButton
            edge="end"
            aria-label="menu"
            onClick={openMobileDrawer}
            sx={{
              display: {
                xs: "flex",
                md: "none",
                color: "#fff",
                marginRight: "0px",
              },
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={closeMobileDrawer}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
        PaperProps={{
        sx: {
          width: '100%',
        },
      }}
        sx={{
          display: { xs: "flex", md: "none" },
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent", // Set background to transparent
            backdropFilter: "blur(16px)",
          },
        }}
      >
        <Box
          sx={{
            background: "#000",
            backdropFilter: "blur(16px)",
            padding:'20px',
            height: '100vh'
          }}
        >
          {/* Header with logo and close button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,              
            }}
          >
            <Typography sx={{ color: "#fff" }}>
              <img src="/logo.png" alt="Logo" />
            </Typography>
            <IconButton
              onClick={closeMobileDrawer}
              sx={{
                color: "#fff",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <List sx={{ paddingTop: "10px", paddingBottom: "30px", }}>
            <Grid>
              <Button
                href="/home"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  mt: "8px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/home_icon.png"
                  style={{ width: "22px", marginRight: "6px" }}
                />
                Home
              </Button>
            </Grid>
            <Grid>
              <Button
                href="/Shop"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  mt: "8px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/shop_icon.png"
                  style={{ width: "22px", marginRight: "6px" }}
                />
                Shop
              </Button>
            </Grid>
            <Grid>
              <Button
                href="/Gallery"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  mt: "8px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/gallery_icon.png"
                  style={{ width: "22px", marginRight: "6px" }}
                />
                Gallery
              </Button>
            </Grid>

            <Grid>
              <Button
                href="/Promotions"
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  mt: "8px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
              >
                <img
                  src="/icons/promotions_icon.png"
                  style={{ width: "22px", marginRight: "6px" }}
                />
                Promotions
              </Button>
            </Grid>

            {/* <Grid>
              <Button
                href=""
                sx={{
                  color: "#81859f",
                  fontSize: "16px",
                  fontWeight: "300",
                  textTransform: "none",
                  bgcolor: "transparent",
                  borderRadius: "20px",
                  px: "16px",
                  mt: "8px",
                  ml: "40px",
                  "&:hover": {
                    color: "#fff",
                    bgcolor: "#6A0DAD",
                  },
                }}
                aria-controls="products-menu"
                aria-haspopup="true"
                onClick={handleMenuOpen}
                endIcon={<ArrowDropDownIcon />}
              >
                <img
                  src="/icons/billing_icon.png"
                  style={{ width: "22px", marginRight: "6px" }}
                />{" "}
               Shop
              </Button>

              <Menu
                id="products-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "products-menu",
                }}
                PaperProps={{ style: { borderRadius: "14px", border: "1px solid transparent",
                  background:
                    "linear-gradient(#0A0A0B, #0A0A0B) padding-box, radial-gradient(circle at top center, #fff -10%, #373737 40%) border-box",} }}
                sx={{ zIndex: "999999" }}
              >
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    color: "#fff",
                    fontFamily: "Poppins",
                    fontWeight: "300",
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                >
                  <Link
                    href=""
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      display: "inherit",
                      "&:hover": {
                      color: "#fff",
                    },
                    }}
                  >
                    <img
                      src="/icons/user_icon.png"
                      style={{ height: "18px", marginRight: "6px" }}
                    />{" "}
                    Caps
                  </Link>
                </MenuItem>
                <MenuItem
                  onClick={handleMenuClose}
                  sx={{
                    color: "#fff",
                    fontFamily: "Poppins",
                    fontWeight: "300",
                    "&:hover": {
                      color: "#fff",
                    },
                  }}
                >
                  <Link
                    href=""
                    sx={{
                      color: "#fff",
                      textDecoration: "none",
                      display: "inherit",
                      "&:hover": {
                      color: "#fff",
                    },
                    }}
                  >
                    <img
                      src="/icons/user_icon.png"
                      style={{ height: "18px", marginRight: "6px" }}
                    />{" "}
                    Sweat Shirts
                  </Link>
                </MenuItem>
              </Menu>
            </Grid> */}

            
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Navbar;
